import React, { FC, JSX } from 'react';
import { Label, LabelProps } from '@silverfort/sf-components';

export interface FormFieldsProps {
    label: string;
    mandatory?: boolean;
    tooltipInfo?: LabelProps['tooltipInfo'];
    Input: JSX.Element;
}

const FormField: FC<FormFieldsProps> = ({ label, mandatory = false, tooltipInfo, Input }) => (
    <div className="flex items-center gap-10">
        <Label mandatory={mandatory} tooltipInfo={tooltipInfo} className="min-w-50" text={label} />
        {Input}
    </div>
);

export default FormField;
